import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const LoadingSplash = () => {
  const [show, setShow] = useState(
    () => !(typeof window !== "undefined" && window.location.search.includes("nosplash"))
  );
  useEffect(() => {
    if (!show) return;
    const id = setTimeout(() => setShow(false), 1700);
    return () => clearTimeout(id);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="app-bg fixed inset-0 z-[200] flex flex-col items-center justify-center"
          data-testid="loading-splash"
        >
          <motion.img
            src="/destin-icon.jpg"
            alt="Destin Express"
            initial={{ scale: 0.6, opacity: 0, rotate: -8 }}
            animate={{ scale: 1, opacity: 1, rotate: 0 }}
            transition={{ type: "spring", stiffness: 200, damping: 12 }}
            className="h-24 w-24 rounded-3xl shadow-[0_0_50px_rgba(240,147,251,0.5)]"
          />
          <motion.h1
            initial={{ y: 16, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.15 }}
            className="mt-5 font-display text-2xl font-black uppercase tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-[#f093fb] to-[#f5576c]"
          >
            Destin Express
          </motion.h1>
          <div className="mt-6 h-1 w-32 overflow-hidden rounded-full bg-white/10">
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: "100%" }}
              transition={{ repeat: Infinity, duration: 1, ease: "easeInOut" }}
              className="h-full w-1/2 bg-gradient-to-r from-[#f093fb] to-[#f5576c]"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
